export default "__VITE_ASSET__RQAi7sFJ__"